import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    basket: [],

    civility: 'M.',
    client_name: null,
    seller: null,
    delivery_type: 1,
    address: null,
    phone: null,
    mail: null,
    date: null,
  },
  mutations: {
    ///// GESTION UTILISATEUR /////
    loginUser(state, sellerName) {
      state.isLoggedIn = true
      state.seller = sellerName
    },
    logoutUser(state) {
      state.isLoggedIn = false
      state.seller = null
    },

    ///// GESTION PANIER /////
    // Ajoute l'objet passé en paramètre dans le tableau basket situé dans le state
    add(state, product) {
      var add = false;
      // Vérifie si le produit est déjà présent dans le panier
      state.basket.forEach(function (item) {
        // Dans le cas où il est présent, on incrémente la quantité désiré
        if (item.id === product.id && item.length === product.length) {
          item.quantity += product.quantity;
          add = true;
        }
      });
      // Sinon, on ajoute l'objet passé en paramètre dans le panier
      if (add === false) {
        state.basket.push(product);
      }
    },
    // Supprime le produit dont l'ID est passé en paramètre du panier
    removeProduct(state, productId) {
      let index = state.basket.map(function (product) { return product.id; }).indexOf(productId);
      state.basket.splice(index, 1);
    },
    // Edite la quantité pour un produit déjà dans le panier
    // @param payload.id : ID du produit dont la quantité doit être modifié
    // @param payload.quantity : nouvelle quantité à attribuer pour le produit
    editQuantity(state, payload) {
      state.basket.forEach(function (item) {
        if (item.id === payload.id) {
          item.quantity = payload.quantity;
        }
      });
    },

    // Edite la longueur pour un produit déjà dans le panier
    // @param payload.id : ID du produit dont la longueur doit être modifié
    // @param payload.length : nouvelle longueur à attribuer pour le produit
    editLength(state, payload) {
      state.basket.forEach(function (item) {
        if (item.id === payload.id) {
          item.length = payload.length;
        }
      });
    },

    // Vide le panier & les infos client
    erase(state) {
      state.basket = []
      state.civility = 'M.'
      state.client_name = null
      state.delivery_type = 1
      state.address = null
      state.phone = null
      state.mail = null
      state.date = null
    },

    ///// GESTION INFORMATIONS CLIENT / LIVRAISON /////
    updateCivility(state, civility) {
      state.civility = civility
    },
    updateClientName(state, client_name) {
      state.client_name = client_name
    },
    updateDeliveryType(state, delivery_type) {
      state.delivery_type = delivery_type
    },
    updateAddress(state, address) {
      state.address = address
    },
    updatePhone(state, phone) {
      state.phone = phone
    },
    updateMail(state, mail) {
      state.mail = mail
    },
    updateDate(state, date) {
      state.date = date
    },
  },
  getters: {
    // Permet de retrouver un produit dans le panier, via l'ID du produit
    // Retourne le produit (objet)
    getProductById: (state) => (id) => {
      return state.basket.find(product => product.id === id)
    },
    getAmountTotal: state => {
      var result = 0;
      state.basket.forEach(function (product) {
        if (product.type == 'cutting'){
          result += product.price * product.coefficient * product.quantity * product.length
        }
        else{
          result += product.price * product.coefficient * product.quantity
        }
      });
      return result.toFixed(2)
    }
  }
})
